export const REWARD_CONFIG: Record<number, { type: "exp" | "pearls" | "mystery" | "energy" | "level"; label: string }> = {
  1: { type: "exp", label: "15,000" },
  2: { type: "pearls", label: "15,000" },
  3: { type: "mystery", label: "Mystery Box" },
  4: { type: "pearls", label: "25,000" },
  5: { type: "exp", label: "25,000" },
  6: { type: "pearls", label: "50,000" },
  7: { type: "mystery", label: "Mystery Box" },
};

export const ICON_PATHS = {
  exp: "/ui/daily-rewards/daily-rewards-exp-gift.png",
  pearls: "/ui/daily-rewards/daily-rewards-pearls-gift.png",
  mystery: "/ui/daily-rewards/daily-rewards-mystery-box.png",
} as const;

export const COLORS = {
  green: "var(--color-brand)",
  gray: "var(--color-text-light)",
  activeGradient: "linear-gradient(to right, var(--color-brand), var(--color-deep-blue))",
  inactiveGradient: "linear-gradient(to right, var(--color-disabled-surface), var(--color-disabled-surface-end))",
} as const;

export const getRewardIcon = (day: number): string => {
  const config = REWARD_CONFIG[day];
  if (!config) return ICON_PATHS.exp;
  
  if (config.type === "pearls") return ICON_PATHS.pearls;
  if (config.type === "mystery") return ICON_PATHS.mystery;
  return ICON_PATHS.exp;
};
